import styled from 'styled-components';
export const IndicatorRect = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: 1px solid transparent;
`;
export const IndicatorTitle = styled.span`
  padding: 5px;
  font-family: 'OpenSans-Regular';
  font-size: 12px;
  color: #828282;
`;
export default {
  IndicatorRect,
  IndicatorTitle
};